// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-title {
  text-align: center;
  font-family: "Yanone Kaffeesatz";
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.3px;
}
:host .loginCard {
  margin: auto;
  max-width: 400px;
}
:host .passwordIcon {
  cursor: pointer;
}
:host ion-content {
  --background: var(--page-background-color);
}

#appVersionWrapper {
  width: 100%;
  text-align: center;
  bottom: 0.7em;
}`, "",{"version":3,"sources":["webpack://./src/app/login/login.page.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,gCAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;AAAR;AAGI;EACI,YAAA;EACA,gBAAA;AADR;AAII;EACI,eAAA;AAFR;AAKI;EACI,0CAAA;AAHR;;AAQA;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AALJ","sourcesContent":[":host {\r\n    ion-title { \r\n        text-align: center;\r\n        font-family: 'Yanone Kaffeesatz';\r\n        text-transform: uppercase;\r\n        font-weight: 500;\r\n        letter-spacing: 0.3px;\r\n    }\r\n\r\n    .loginCard {\r\n        margin: auto;\r\n        max-width: 400px;\r\n    }\r\n\r\n    .passwordIcon {\r\n        cursor: pointer;\r\n    }\r\n\r\n    ion-content {\r\n        --background: var(--page-background-color);\r\n    }\r\n\r\n}\r\n\r\n#appVersionWrapper {\r\n    width: 100%;\r\n    text-align: center;\r\n    bottom: .7em;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
